import {
  CoreContainerProperties,
  CoreContainerState,
  withAuthorPanelSwitch,
  withStandardBaseCssClass
} from '@adobe/aem-core-components-react-spa'
import { ComponentMapping, Constants, Container } from '@adobe/aem-react-editable-components'

import RevealCards from './RevealCards'
import { ReactRevealCardsProps } from './types'
import { removeEmptyCF } from '../../utils/rule-builder-util'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'

interface ReactRevealCardsState extends CoreContainerState {
  activeIndex: number
  previousIndex: number
}

class ReactRevealCards extends Container<ReactRevealCardsProps, ReactRevealCardsState> {
  interval = 0

  constructor(props: ReactRevealCardsProps) {
    super(props)
    this.state = {
      activeIndex: 0,
      previousIndex: 0,
      componentMapping: this.props.componentMapping || ComponentMapping
    }
  }

  componentDidUpdate(prevProps: Readonly<CoreContainerProperties>): void {
    if (
      this.props.activeIndexFromAuthorPanel !== undefined &&
      prevProps.activeIndexFromAuthorPanel != this.props.activeIndexFromAuthorPanel
    ) {
      this.setState({ activeIndex: this.props.activeIndexFromAuthorPanel })
    }
  }

  displayItem(item: JSX.Element, index: number) {
    const isActive = index === this.state.activeIndex
    //we display the item if active is true, or if we are in the author mode. we need to always display the item for the author mode to work properly.
    const display = !!(isActive || this.props.isInEditor)

    const cssClass = isActive
      ? `${this.props.baseCssClass}__item ${this.props.baseCssClass}__item--active`
      : `${this.props.baseCssClass}__item`

    return (
      <div key={'item-' + index} className={cssClass} role='tabpanel' data-cmp-hook-teaser='item'>
        {display && item}
      </div>
    )
  }

  renderRevealCards() {
    const { cqItems = {}, cqItemsOrder = [], isInEditor = false } = this.props
    const itemsOrder = (cqItemsOrder.length > 0 ? cqItemsOrder : this.props[Constants.ITEMS_ORDER_PROP]) || []
    const items: any = (Object.keys(cqItems).length > 0 ? cqItems : this.props[Constants.ITEMS_PROP]) || {}
    const contentFragments: any = removeEmptyCF(itemsOrder.map((i: string) => items[i]))

    return (
      <>
        {IsInEditorText(isInEditor, 'React Reveal Cards')}
        {this.childComponents.map((childComponent, index) => this.displayItem(childComponent, index))}
        <RevealCards contentFragments={contentFragments} {...this.props} />
      </>
    )
  }

  render() {
    const { top = false, right = false, bottom = false, left = false, lob = '', baseCssClass } = this.props

    return (
      <div
        data-testid={`react-reveal-cards-container`}
        className={`react-reveal-cards-container ${getSpacing(top, right, bottom, left)} ${lob}`}
        id={this.props.id}
      >
        <div
          className={baseCssClass}
          role='group'
          data-panelcontainer='reveal-cards'
          aria-roledescription='reveal-cards'
        ></div>
        {this.renderRevealCards()}
      </div>
    )
  }
}

export default withStandardBaseCssClass(withAuthorPanelSwitch(ReactRevealCards), 'cmp-teaser')
